export default __webpack_public_path__ + "static/ensbook-435384b24c752f6a20ab871e61b27e1f.jpg";